/**
 * 全局配置文件
 * @description 用于管理API地址等配置信息
 */

export default {
    // API 地址
    apiUrl: process.env.VUE_APP_API_URL || 'https://suyuan.hulianzaowu.com',
    
    // 公司信息
    company: {
        name: '安徽勺子同学科技有限公司',
        tel: '400-888-8888',
        email: 'info@hulianzaowu.com',
        address: '安徽省'
    }
};
